import React from 'react'
import Total from '../components/Overview/Cards'
import { WaveChart } from '../components/Overview/graphs/Graphs'
import { Circle } from '../components/Overview/graphs/Circle'

import { men } from '../../data/product';
const Overview = () => {
  const products =men.slice(0,5);
  return (
     <div className='px-[3rem]'>
         <Total/>
         <div className='flex justify-center items-cener gap-[2rem] text-white mt-[1rem]'>
             <WaveChart/>
             <Circle/>
         </div>
         <div className="w-full flex flex-wrap justify-between items-start gap-4 mt-6">
 <div className="basis-[68%] min-w-[300px] h-[200px] flex  flex-col  gap-[0.2rem] bg-gray-700 rounded-xl p-2  overflow-hidden">
        <h1 className='font-bold text-[1.4rem]'>Featured Products</h1>
      <div className='flex gap-[0.5rem] h-[180px]'>
      {products.map((product,index)=>(
         <div className='flex flex-col justify-center items-center gap-[0.5rem] p-2 bg-gray-600 w-[150px] h-[100%] rounded-xl'>
              <img src={product.image} alt={product.title}  className='w-[70px] h-[70px]'/>
              <div>
                 <h1 className='font-noraml text-[13px]'>{product.title}</h1>
                 <p>${product.price}</p>
              </div>
         </div>
      ))}
      </div>
</div>


  <div className="flex-[0_0_30%] h-[200px] bg-gray-700 min-w-[200px] rounded-xl p-[1rem]">
        <h1 className='font-bold text-[1.4rem]'>Regular Clients</h1>
        <div className='flex flex-col gap-[0.5rem]'>
           <div className='flex gap-[0.5rem] items-center'>
                <img src="https://i.pinimg.com/236x/1e/de/b7/1edeb7e0d6911d56e44d215a18adc659.jpg" alt=""  className='w-[35px] h-[35px] rounded-full'/>
                    <h1 className='font-bold text-[1rem]'>Michel Santner</h1>
           </div>
           <div className='flex gap-[0.5rem] items-center'>
                <img src="https://img.freepik.com/free-photo/rendering-bee-anime-character_23-2150963632.jpg?semt=ais_wordcount_boost&w=740&q=80" alt=""  className='w-[35px] h-[35px] rounded-full'/>
                    <h1 className='font-bold text-[1rem]'>Marry Thomas</h1>
            
           </div>
           <div className='flex gap-[0.5rem] items-center'>
                <img src="https://avatarfiles.alphacoders.com/715/thumb-350-71560.webp" alt=""  className='w-[35px] h-[35px] rounded-full'/>
                    <h1 className='font-bold text-[1rem]'>Michel Marsh</h1>
            
           </div>
        </div> 
  </div>
</div>

     </div>
  )
}

export default Overview
